import axios from 'axios'
import _ from 'lodash' //Imported from lodash js library in the index.html page

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentVersion: 'v0.9.7',
    currentViewState: 'homeview', //homeview, recordview, aboutview (homeview should be the default)
    currentRecordType: 'typeface', //typeface, resource, concept (typefacerecord should be default)
    currentTypefaceRecordID: 'T19636', //ID Of the selected record (the first typeface record should be default)
    currentConceptRecordID: 'C19612',
    currentResourceRecordID: 'R89694',
    fetchedTypefaceData: false, //Have individual JSON files been grabbed?
    fetchedConceptData: false,
    fetchedResourceData: false,
    fetchedData: false, //Has ALL the JSON files been grabbed?
    fetchedTypefaces: [], //Will be filled with the JSON data
    fetchedConcepts: [],
    fetchedResources: [],
    recordsCombined: false, //Have the 3 types of records been combined together?
    combinedRecords: [],
    menuOpened: false,
    zoomOpened: false,
    zoomFigure: 'C19612_fig01.svg' //Needs an initial image to start with; otherwise will generate uncaught promise if using Object for SVG
  },
  mutations: {
    updateCurrentVersion(state, currentVersion){
      state.currentVersion = currentVersion
    },
    updateCurrentView(state, currentViewState){
      state.currentViewState = currentViewState
    },
    updateCurrentRecordType(state, currentRecordType){
      state.currentRecordType = currentRecordType
    },
    updateTypefaceRecordID(state, currentTypefaceRecordID){
      state.currentTypefaceRecordID = currentTypefaceRecordID
    },
    updateConceptRecordID(state, currentConceptRecordID){
      state.currentConceptRecordID = currentConceptRecordID
    },
    updateResourceRecordID(state, currentResourceRecordID){
      state.currentResourceRecordID = currentResourceRecordID
    },
    updateMenuOpened(state, menuOpened){
      state.menuOpened = menuOpened
    },
    updateZoomOpened(state, zoomOpened){
      state.zoomOpened = zoomOpened
    },
    updateZoomFigure(state, zoomFigure){
      state.zoomFigure = zoomFigure
    },
  },
  getters: {
    zoomOpened: state => state.zoomOpened,
    zoomFigure: state => state.zoomFigure,
    menuOpened: state => state.menuOpened,
    currentVersion: state => state.currentVersion,
    currentViewState: state => state.currentViewState, //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/Arrow_functions
    currentRecordType: state => state.currentRecordType,
    currentTypefaceRecordID: state => state.currentTypefaceRecordID,
    currentConceptRecordID: state => state.currentConceptRecordID,
    currentResourceRecordID: state => state.currentResourceRecordID,
    fetchedTypefaceData: state => state.fetchedTypefaceData,
    fetchedConceptData: state => state.fetchedConceptData,
    fetchedResourceData: state => state.fetchedResourceData,
    fetchedData: state => state.fetchedData,
    fetchedTypefaces: state => state.fetchedTypefaces,
    fetchedConcepts: state => state.fetchedConcepts,
    fetchedResources:state => state.fetchedResources,
    typefaceDataLength: function(state){
      return state.fetchedTypefaces.length
    },
    conceptDataLength: function(state){
      return state.fetchedConcepts.length
    },
    resourceDataLength: function(state){
      return state.fetchedResources.length
    },
    recordsCombined:state => state.recordsCombined,
    combinedRecords: function(state){ //  Same as: combinedRecords:state => state.combinedRecords,
      return state.combinedRecords
    },
    //Sort All Records by English, Alpha, Asc
    combinedRecordsSortedEng: function(state){
      return _.orderBy(state.combinedRecords, [item => item.nameeng.toLowerCase()]) 
      //https://stackoverflow.com/questions/37848030/lodash-how-to-do-a-case-insensitive-sorting-on-a-collection-using-orderby
      
    },
    //Sort All Records by Chinese, Unicode, Asc
    combinedRecordsSortedCh: function(state){
      return _.orderBy(state.combinedRecords, 'namech') 
    },
    //Sort Typefaces: nameeng
    sortTypefacesAscnameeng: function(state){
      return _.orderBy(state.fetchedTypefaces, 'nameeng') 
    },
    //Sort Typefaces: namech
    sortTypefacesAscnamech: function(state){
      return _.orderBy(state.fetchedTypefaces, 'namech') 
    },
    //Sort Typefaces: creatoreng
    sortTypefacesAsccreatoreng: function(state){
      return _.orderBy(state.fetchedTypefaces, 'creatoreng') 
    },
    //Sort Typefaces: creatorch
    sortTypefacesAsccreatorch: function(state){
      return _.orderBy(state.fetchedTypefaces, 'creatorch') 
    },
    //Sort Typefaces: foundryeng
    sortTypefacesAscfoundryeng: function(state){
      return _.orderBy(state.fetchedTypefaces, 'foundryeng') 
    },
    //Sort Typefaces: foundrych
    sortTypefacesAscfoundrych: function(state){
      return _.orderBy(state.fetchedTypefaces, 'foundrych') 
    },
    //Sort Typefaces: genreeng
    sortTypefacesAscgenreeng: function(state){
      return _.orderBy(state.fetchedTypefaces, 'genreeng') 
    },
    //Sort Typefaces: genrech
    sortTypefacesAscgenrech: function(state){
      return _.orderBy(state.fetchedTypefaces, 'genrech') 
    },
    //Sort Typefaces: material
    sortTypefacesAscmaterial: function(state){
      return _.orderBy(state.fetchedTypefaces, 'material') 
    },
    //Sort Typefaces: technique
    sortTypefacesAsctechnique: function(state){
      return _.orderBy(state.fetchedTypefaces, 'technique') 
    },
    //Sort Typefaces: creationbegindate
    sortTypefacesAsccreationbegindate: function(state){
      return _.orderBy(state.fetchedTypefaces, 'creationbegindate') 
    },
    //Sort Typefaces: creationenddate
    sortTypefacesAsccreationenddate: function(state){
      return _.orderBy(state.fetchedTypefaces, 'creationenddate') 
    },
    //Sort Typefaces: recordid
    sortTypefacesAscrecordid: function(state){
      return _.orderBy(state.fetchedTypefaces, 'recordid') 
    },

    //Sort Concepts: nameeng
    sortConceptsAscnameeng: function(state){
      return _.orderBy(state.fetchedConcepts, 'nameeng') 
    },
    //Sort Concepts: namech
    sortConceptsAscnamech: function(state){
      return _.orderBy(state.fetchedConcepts, 'namech') 
    },
    //Sort Concepts: category?
    sortConceptsAsctype: function(state){
      return _.orderBy(state.fetchedConcepts, 'type') 
    },
    //Sort Concepts: recordid
    sortConceptsAscrecordid: function(state){
      return _.orderBy(state.fetchedConcepts, 'recordid') 
    },
    
    //Sort Resources: nameeng
    sortResourcesAscnameeng: function(state){
      return _.orderBy(state.fetchedResources, 'nameeng') 
    },
    //Sort Resources: namech
    sortResourcesAscnamech: function(state){
      return _.orderBy(state.fetchedResources, 'namech') 
    },
    //Sort Author: author
    sortResourcesAscauthor: function(state){
      return _.orderBy(state.fetchedResources, 'author') 
    },
    //Sort Author: type
    sortResourcesAsctype: function(state){
      return _.orderBy(state.fetchedResources, 'type') 
    },
    //Sort Resources: date
    sortResourcesAscdate: function(state){
      return _.orderBy(state.fetchedResources, 'date') 
    },
    //Sort Resources: recordid
    sortResourcesAscrecordid: function(state){
      return _.orderBy(state.fetchedResources, 'recordid') 
    },

    //Sort Desc Typefaces: nameeng
    sortTypefacesDescnameeng: function(state){
      return _.orderBy(state.fetchedTypefaces, 'nameeng', 'desc') 
    },
    //Sort Desc Typefaces: namech
    sortTypefacesDescnamech: function(state){
      return _.orderBy(state.fetchedTypefaces, 'namech', 'desc') 
    },
    //Sort Desc Typefaces: creatoreng
    sortTypefacesDesccreatoreng: function(state){
      return _.orderBy(state.fetchedTypefaces, 'creatoreng', 'desc') 
    },
    //Sort Desc Typefaces: creatorch
    sortTypefacesDesccreatorch: function(state){
      return _.orderBy(state.fetchedTypefaces, 'creatorch', 'desc') 
    },
    //Sort Desc Typefaces: foundryeng
    sortTypefacesDescfoundryeng: function(state){
      return _.orderBy(state.fetchedTypefaces, 'foundryeng', 'desc') 
    },
    //Sort Desc Typefaces: foundrych
    sortTypefacesDescfoundrych: function(state){
      return _.orderBy(state.fetchedTypefaces, 'foundrych', 'desc') 
    },
    //Sort Desc Typefaces: genreeng
    sortTypefacesDescgenreeng: function(state){
      return _.orderBy(state.fetchedTypefaces, 'genreeng', 'desc') 
    },
    //Sort Desc Typefaces: genrech
    sortTypefacesDescgenrech: function(state){
      return _.orderBy(state.fetchedTypefaces, 'genrech', 'desc') 
    },
    //Sort Desc Typefaces: material
    sortTypefacesDescmaterial: function(state){
      return _.orderBy(state.fetchedTypefaces, 'material', 'desc') 
    },
    //Sort Desc Typefaces: technique
    sortTypefacesDesctechnique: function(state){
      return _.orderBy(state.fetchedTypefaces, 'technique', 'desc') 
    },
    //Sort Desc Typefaces: creationbegindate
    sortTypefacesDesccreationbegindate: function(state){
      return _.orderBy(state.fetchedTypefaces, 'creationbegindate', 'desc') 
    },
    //Sort Desc Typefaces: creationenddate
    sortTypefacesDesccreationenddate: function(state){
      return _.orderBy(state.fetchedTypefaces, 'creationenddate', 'desc') 
    },
    //Sort Desc Typefaces: recordid
    sortTypefacesDescrecordid: function(state){
      return _.orderBy(state.fetchedTypefaces, 'recordid', 'desc') 
    },

    //Sort Desc Concepts: nameeng
    sortConceptsDescnameeng: function(state){
      return _.orderBy(state.fetchedConcepts, 'nameeng', 'desc') 
    },
    //Sort Desc Concepts: namech
    sortConceptsDescnamech: function(state){
      return _.orderBy(state.fetchedConcepts, 'namech', 'desc') 
    },
    //Sort Desc Concepts: category?
    sortConceptsDesctype: function(state){
      return _.orderBy(state.fetchedConcepts, 'type', 'desc') 
    },
    //Sort Desc Concepts: recordid
    sortConceptsDescrecordid: function(state){
      return _.orderBy(state.fetchedConcepts, 'recordid', 'desc') 
    },
    
    //Sort Desc Resources: nameeng
    sortResourcesDescnameeng: function(state){
      return _.orderBy(state.fetchedResources, 'nameeng', 'desc') 
    },
    //Sort Desc Resources: namech
    sortResourcesDescnamech: function(state){
      return _.orderBy(state.fetchedResources, 'namech', 'desc') 
    },
    //Sort Desc Author: author
    sortResourcesDescauthor: function(state){
      return _.orderBy(state.fetchedResources, 'author', 'desc') 
    },
    //Sort Desc Author: type
    sortResourcesDesctype: function(state){
      return _.orderBy(state.fetchedResources, 'type', 'desc') 
    },
    //Sort Desc Resources: date
    sortResourcesDescdate: function(state){
      return _.orderBy(state.fetchedResources, 'date', 'desc') 
    },
    //Sort Desc Resources: recordid
    sortResourcesDescrecordid: function(state){
      return _.orderBy(state.fetchedResources, 'recordid', 'desc') 
    }
  },
  actions: {
    getData(){
      /* eslint-enable no-console */
      //console.log('data fetched: ' + this.state.fetchedData)
      /* eslint-disable no-console */
      if(!this.state.fetchedTypefaceData){
        axios.get(`cta/178ab4c20435936428f89a409a239cd8.json`).then(resp => {
          this.state.fetchedTypefaces = resp.data.typefaces
          this.state.fetchedTypefaceData = true;
          this.dispatch('combineData')
        })
      }

      if(!this.state.fetchedConceptData){
        axios.get(`cta/47cb06083e87503762f6746725117a3c.json`).then(resp => {
          this.state.fetchedConcepts = resp.data.concepts
          this.state.fetchedConceptData = true;
          this.dispatch('combineData')
        })
      }

      if(!this.state.fetchedResourceData){
        axios.get(`cta/96ab4e163f4ee03aaa4d1051aa51d204.json`).then(resp => {
          this.state.fetchedResources = resp.data.resources
          this.state.fetchedResourceData = true;
          this.dispatch('combineData')
        })
      }
    },
    combineData(){
      //If all the individual JSON files are fetched, 
      if(this.state.fetchedTypefaceData && this.state.fetchedConceptData && this.state.fetchedResourceData){
        this.state.fetchedData = true;
        //And if they haven't been combined together, then combine
        if(!this.state.recordsCombined){

        var typearray = []
        var recordidarray = []
        var namecharray = []
        var nameengarray = []

        //Loop through Typefaces and extract recordid, namech, nameeng
        for (var key1 in this.state.fetchedTypefaces) {
          typearray.push('typeface')
          recordidarray.push(this.state.fetchedTypefaces[key1].recordid)
          namecharray.push(this.state.fetchedTypefaces[key1].namech)
          nameengarray.push(this.state.fetchedTypefaces[key1].nameeng)
        }
        //Loop through Concepts and extract recordid, namech, nameeng
        for (var key2 in this.state.fetchedConcepts) {
          typearray.push('concept')
          recordidarray.push(this.state.fetchedConcepts[key2].recordid)
          namecharray.push(this.state.fetchedConcepts[key2].namech)
          nameengarray.push(this.state.fetchedConcepts[key2].nameeng)
        }
        //Loop through Resources and extract recordid, namech, nameeng
        for (var key3 in this.state.fetchedResources) {
              typearray.push('resource')
              recordidarray.push(this.state.fetchedResources[key3].recordid)
              namecharray.push(this.state.fetchedResources[key3].namech)
              nameengarray.push(this.state.fetchedResources[key3].nameeng)
        }
        //Map together
        this.state.combinedRecords = typearray.map((v,i) => 
          ({"type": typearray[i],"recordid": recordidarray[i],"namech": namecharray[i],"nameeng": nameengarray[i]})
        )

        /* eslint-disable no-console */
        //console.log(this.state.combinedRecords)
        /* eslint-disable no-console */
        }
    }
    }
  }, 
  modules: {
  }
})

//There is still a potential of the data not loading in time and thus, the side showing an error
//We may need to include a watch function
//https://stackoverflow.com/questions/36405588/precedence-in-lifecycle-hooks-with-vue-js-and-vue-router
